import request from '@/plugin/axios'

export function exportData (name) {
  return request({
    url: '/study/export-data?name=' + name,
    method: 'post',
    responseType: 'arraybuffer'
  })
}
